export function generateDatosCliente(cuenta) {
  return {
    alignment: 'justify',
    columnGap: 20, // Agrega un espacio de 20 puntos entre las columnas
    columns: [
      {
        stack: [
          { text: 'Datos del cliente', style: 'clienteTitulo' },
          { text: (cuenta.documento ?? '') + ' ' + cuenta.razon_social },
        ]
      },
      {
        stack: [
          { text: 'Datos de la cuenta', style: 'clienteTitulo' },
          { text: (cuenta.numero ?? '') + ' ' + (cuenta.descripcion ?? '') },
        ]
      },
    ]
  };
}
